interface Props {
  content: any;
  size?: "small" | "medium" | "large";
  width?: string;
}

export const Modal = (props: Props) => {
  const { content, size, width } = props;

  const getSize = (size: string | undefined) => {
    switch (size) {
      case "small":
        return "250px";
      case "medium":
        return "510px";
      default:
        return "100%";
    }
  };

  const getMinSize = (size: string | undefined) => {
    switch (size) {
      case "small":
        return "0px";
      case "medium":
        return "510px";
      default:
        return "92%";
    }
  };

  return (
    <>
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div
          className="modal-card"
          style={{
            width: width ?? "",
            height: getSize(size),
            minHeight: getMinSize(size),
          }}
        >
          {content}
        </div>
      </div>
    </>
  );
};
